<template>
    <div class="header">
    
        <header class="fix-header">
            <section class="header-content">
                <img src="../../assets/mobile/logo-header.png" alt="" class="logo" @click="handleIndex" />
    
                <img src="../../assets//mobile/menu-2.svg" class="menu" @click="tooglePop">
            </section>
    
            <van-popup  :overlay=false v-model="popShow" position="right" class="popup">
                <navBarMobile :visible.sync="popShow" :list="list"></navBarMobile>
            </van-popup>
    
        </header>
    </div>

</template>
  
<script>
import { getUser, getToken, removeToken, removeUser } from "@/utils/auth.js";

import navBarMobile from "./navBar-mobile.vue";
import defaultAvatar from "@/assets/defaultAvatar.svg";
import loginOutSvg from "@/assets/login-out.svg";

export default {
    components: {
        navBarMobile,
    },
    data() {
        return {

            isLogin: false,
            defaultAvatar,
            loginOutSvg,
            popShow: false,
            userInfo: getUser(),
        };
    },
    created() {


        this.refresh();
        // 为登录框添加刷新事件监听器
        this.$loginBox.addEventListener(this.refresh);

    },

    methods: {

        /**
         * 刷新方法
         * 该方法用于检查用户登录状态并获取用户信息
         */
        refresh() {
            this.isLogin = !!getToken();
            this.userInfo = getUser();

            if (this.isLogin && this.userInfo) {
                this.$fetch.post('/api/user/check-status');
            }
        },

        // 跳转到主页
        handleIndex() {
            this.popShow = false;
            if (this.$router.currentRoute.name !== 'index') {
                this.$router.push({
                    name: 'index',
                });
            }

        },

        avatar(userInfo) {
            return userInfo.avatar || this.defaultAvatar;
        },



        handleLogin() {
            this.$loginBox.show('login');
        },

        handleRegister() {
            this.$loginBox.show('register');
        },

        handleLoginOut() {
            removeToken();
            removeUser();
            window.location.reload();
        },

        tooglePop() {
            this.popShow = !this.popShow;
        }



    },
};
</script>
  
<style lang="less" scoped>

.header {
    height: 60px;
}
.fix-header {
    background: #3762ac;
    box-sizing: border-box;
    width: 100vw;
    z-index: 1000;
    top: 0;
    overflow: hidden;
    height: 60px;
    margin: 0px auto;
    position: fixed;

    .header-content {
        height: 60px;
        padding: 10px 20px;
        background: transparent;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        z-index: 9999;

        .logo {
            // margin: 0 auto;
            width: 60%;
            // margin-left: 10%;
        }

        .menu {
            width: 16px;
            height: 16px;
        }

    }


}

.popup {
    width: 100%;
    margin-top: 60px;
    height: 100vh;
}
</style>
  